import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { readShadeThunk } from './thunks/read-shade-thunk';
import { saveShadeThunk } from './thunks/save-shade-thunk';

export enum ShadeMode {
  Light = 'light',
  Dark = 'dark'
}

export interface ThemeState {
  mode: ShadeMode;
}

const initialState: ThemeState = {
  mode: ShadeMode.Light,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setThemeMode: (state, action: PayloadAction<ShadeMode>) => {
      state.mode = action.payload;
    },
    toggleThemeMode: (state) => {
      state.mode = state.mode === ShadeMode.Light ? ShadeMode.Dark : ShadeMode.Light;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(readShadeThunk.fulfilled, (state, action) => {
        state.mode = action.payload;
      })
      .addCase(saveShadeThunk.fulfilled, () => {
        // Mode already set, just acknowledge save completed
      });
  },
});

export const { setThemeMode, toggleThemeMode } = themeSlice.actions;
export default themeSlice.reducer;
